import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const BoosterIcon = ({
  width = 22,
  height = 19,
  color,
  ...rest
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M22 16.8193C22 17.534 21.4207 18.1132 20.7061 18.1133H1.29395C0.579303 18.1132 0 17.534 0 16.8193V9.05469H22V16.8193ZM20.7061 0.00390625C21.4205 0.00426282 22 0.58335 22 1.29785V7.76855H14.2354V0.00390625H20.7061ZM12.9414 7.76465H0V1.29395C0 0.579281 0.579303 9.31409e-05 1.29395 0H12.9414V7.76465ZM18.0947 1.42969C16.7494 1.42972 15.6592 2.5199 15.6592 3.86523C15.6594 5.21035 16.7496 6.30075 18.0947 6.30078C19.4398 6.3006 20.531 5.21026 20.5312 3.86523C20.5312 2.51999 19.4399 1.42987 18.0947 1.42969Z"
        fill={currentColor}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default BoosterIcon;
